import React from 'react';
import LoginLeftPanel from '../../components/Login/LoginLeftPanel.jsx';
import LogoCardWrapper from "./LogoCardWrapper";

export default class LoginTemplate extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            phoneNumber: "",
            readyForVerificationCode: false,
            verificationCode: ""
        };

        this.state = {hidePanel: window.matchMedia("(max-width: 991px)").matches};

        var self = this
        window.matchMedia("(max-width: 991px)").addEventListener("change", (e) => {
            if (e.matches != this.state.hidePanel) {
                self.setState({hidePanel: e.matches});
            }
        });
    }

    render() {
        return (
            <div className="new-login">
                <div style={{height: "100vh", overflow: "auto"}}>
                    {this.state.hidePanel ? (
                        <div style={{
                            display: "flex",
                            justifyContent: "center",
                            paddingLeft: "15px",
                            paddingRight: "15px"
                        }}>
                            <div className="col-xs-12 login-input">
                                <LogoCardWrapper logoOptions={this.props.logoOptions} cardView={this.props.cardView} hidePanel={true}/>
                            </div>
                        </div>
                    ) : (
                        <div className="col-md-12 col-no-pad" style={{}}>
                            <div className="col-md-4 col-no-pad" style={{overflowY: "hidden", position: "fixed"}}>
                                <div className="row login-panel-row">
                                    <LoginLeftPanel/>
                                </div>
                            </div>
                            <div className="col-md-8 login-right-panel" style={{float: "right"}}>
                                <LogoCardWrapper logoOptions={this.props.logoOptions} cardView={this.props.cardView} hidePanel={false}/>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        )
    }
};



// WEBPACK FOOTER //
// app/components/Login/LoginTemplate.jsx